import React from 'react';
import ReactDOM from 'react-dom';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';

import 'bulma/css/bulma.css';
import 'bulma-divider/dist/css/bulma-divider.min.css';
import './index.css';
import store, { history } from './store';
import { unregister } from './registerServiceWorker';

import App from './App';
import Home from './screens/Home/HomeContainer';
import Contacts from './screens/Contacts/components/Contacts';
import NoSupport from './screens/NoSupport/components/NoSupport';
import Cfs from './screens/CallForSpeakers/CFSContainer';
import SpeakersContainer from './screens/Speakers/SpeakersContainer';
import SpeakerDetailsContainer from './screens/SpeakerDetails/SpeakerDetailsContainer';
import TalkDetailContainer from './screens/TalkDetail/TalkDetailContainer';
import ProgramContainer from './screens/Program/ProgramContainer';
import WorkshopsContainer from './screens/Workshops/WorkshopsContainer';
import FeedbackFormContainer from './screens/FeedbackForm/FeedbackFormContainer';
import FeedbackFormWorkshopContainer from './screens/FeedbackFormWorkshop/FeedbackFormWsContainer';
import LocationMap from './screens/LocationMap/LocationMap';

const Routes = (
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App>
                <Route component={Home} exact path="/" />
                <Route component={Cfs} exact path="/cfs" />
                <Route component={FeedbackFormContainer} exact path="/ff" />
                <Route component={FeedbackFormWorkshopContainer} exact path="/workshops/:id/ff" />
                <Route component={SpeakersContainer} exact path="/speakers" />
                <Route component={SpeakerDetailsContainer} exact path="/speakers/:id" />
                <Route component={TalkDetailContainer} exact path="/program/:id" />
                <Route component={TalkDetailContainer} exact path="/workshops/:id" />
                <Route component={Contacts} exact path="/contacts" />
                <Route component={ProgramContainer} exact path="/program" />
                <Route component={LocationMap} exact path="/location-map" />
                <Route component={WorkshopsContainer} exact path="/workshops" />
            </App>
        </ConnectedRouter>
    </Provider>
);

const isIE = /* @cc_on!@ */ false || !!document.documentMode;
if (isIE) {
    ReactDOM.render(<NoSupport />, document.getElementById('root'));
} else {
    ReactDOM.render(Routes, document.getElementById('root'));
}

unregister();
